import Vue from 'vue'
import Vuetify from 'vuetify'
import * as allVuetifyComponents from 'vuetify/lib'

import { TcThemeLight } from '@tangocard/swag'
import '@mdi/font/css/materialdesignicons.css'
// importing our custom tc icons css here allows you to use them in vuetify icon component
// e.g. <v-icon>tci-cloud-download</v-icon>
import '@tangocard/swag/dist/tc-icons/tc-icons.css'

const RewardLinkTheme = {
  ...TcThemeLight,
  // #208195 is a more accessible version of our normal "teal" primary color.
  // For now we are going to hard-code it here to get RL to meet accessibility
  // requirements -- eventually we are going to restructure and re-strategize
  // how we do colors in Mango
  primary: '#208195'
}

const config = {
  components: {
    ...allVuetifyComponents
  },
  icons: {
    iconfont: 'mdi'
  },
  breakpoint: {
    mobileBreakpoint: 768
  },
  theme: {
    options: {
      // https://vuetifyjs.com/en/customization/theme/#custom-properties
      customProperties: true
    },
    themes: {
      light: {
        ...RewardLinkTheme
      }
    }
  }
}

Vue.use(Vuetify)

export default new Vuetify(config)
